import { TicketRepository } from '../repositories/TicketRepository'

export function ListIndicatorsMetricsTmeCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    areaId,
    data
  }: {
    areaId: string
    data: {
      month: number
      year: number
    }
  }) {
    return await ticketRepository.listIndicatorsMetricsTme({ areaId, data })
  }
}
